import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/web-icons/instagram.png")